<template>
  <div class="xes-1v1-login-div">

    <div class="xes-1v1-login-code" id="xes-1v1-login-code">
      <h2 class="xes-1v1-login-code-title">{{ loginTitle }}</h2>
      <p class="xes-1v1-login-code-tips">未注册手机号登录后将自动生成学而思1对1账户</p>

      <div class="xes-1v1-login-code-phone">
        <!-- 账号密码登录时不需要选择区号 -->
        <div class="xes-1v1-login-code-phone-phone">
          <span class="xes-1v1-login-code-area-code">+86</span>
          <input class="xes-1v1-login-code-phone-input" v-model="phoneNo" type="tel" ref="phoneNo" maxlength="13"
                 :placeholder="placeholderText" @keyup="inputMobile" @paste="inputMobile" @blur="inputBlur(1)"
                 @focus="inputFoucs(1)"/>

        </div>
        <!--      <div class="xes-1v1-login-code-bottom-line"></div>-->
        <div class="xes-1v1-login-code-phone-code">
          <input class="xes-1v1-login-code-phone-code-input"
                 v-model="phoneCode"
                 @blur="inputBlur(2)"
                 @focus="inputFoucs(2)"
                 @keyup="inputMobileCode"
                 type="text"
                 :placeholder="placeholderPwdText"
                 oninput="value=value.replace(/[^\d]/g,'')"
                 maxlength="6"/>
          <button class="xes-1v1-login-code-phone-code-get-code" @click="sendSms">{{ getCodeText }}
            <i class="code-sended-msg" v-if="codeSended">后重新获取</i>
          </button>
          <!-- <div class="xes-1v1-login-code-bottom-line"></div> -->
        </div>


      </div>

      <div class="xes-1v1-login-code-protcal">
        <img class="xes-1v1-login-code-protcal-circle-select"
             @click="agreeProtocal" :src="getAgreeImg" alt=""/>
        <div class="xes-1v1-login-code-protcal-text">
          <!--        <span >未注册的手机号将自动为您创建账号</span>-->
          <!--           @click="clickProtocal('https://octopus.xes1v1.com/')"-->
          <span class="xes-1v1-login-code-protcal-des">登录即代表您同意</span>
          <a class="xes-1v1-login-code-protcal-link"
             @click="clickProtocal('https://octopus.xes1v1.com/projectAgreementForAndroid.html')"
             target="_blank">《学而思1对1-用户个人信息保护政策》</a>
          <a class="xes-1v1-login-code-protcal-link"
             @click="clickProtocal('https://octopus.xes1v1.com/projectAgreementForIoskid.html')"
             target="_blank">《学而思1对1-儿童信息保护规则》</a>
          <!--        <a @click="clickProtocal('https://www.baidu.com')" target="_blank">隐私协议</a>、-->
          <!--        <a @click="clickProtocal('https://www.baidu.com')" target="_blank">儿童隐私协议</a>-->
        </div>
      </div>
      <div class="xes-1v1-login-code-btn" @click="loginWithCode">
        <button :disabled="!phoneNo || !phoneCode"
                :class="{ active: phoneNo && phoneCode && isSelectProtocal }">
          登录
        </button>
      </div>
      <div class="xes-1v1-login-code-switch">
        <p @click="switchAccountLogin">账户密码登录</p>
      </div>
    </div>

    <div id="loadingToast" class="loading_toast" v-show="loading">
      <div class="loading_mask_transparent"></div>
      <div class="gif-loading"></div>
    </div>
  </div>
</template>
<script>

import {number} from "echarts";

import {Toast} from "vant";
import TAL_UC from '@udc/tal-passport-jssdk'

export default {
  data() {
    return {
      userInfo: {}, // 用户信息: isNew< 0是老用户, 1新注册用户>
      loginText: '',
      phoneNo: '',
      phoneCode: '',
      userNum: '',
      password: '',
      codeSended: false,
      verifyCode: '', // 隐藏input的二维码value
      verifyCodeArr: new Array(6), // 6个二维码数值
      codeType: 1, // 1验证码登录 9找回密码 2密码
      seconds: 60,
      showSeconds: true,
      timer: null, // 定时器
      isShowQuestions: false,
      pwdType: 'password',
      changePhoneType: false,
      phoneType: 1,
      callCustom: false,
      clientHeight: document.documentElement.clientHeight,
      showBtn: true,
      positionTimer: null,
      isSelectProtocal: false, // 是否勾选协议
      warnProtocal: false, // 不勾选协议时的警报
      isShowPhoneX: false,
      isShowCodeX: false,
      getCodeText: '获取验证码',
      showResetPwd: false, // 是否展示重置密码输入框
      user_uid: 0,
      user_grade: 0,
      user_city_code: 0,
      user_city_name: 0,
      user_grade_name: 0,
      user_real_name: 0,
      user_avatar_url: 0,
      user_sex: 1,//默认男
      loading: false
    }
  },


  computed: {
    number() {
      return number
    },
    loginTitle() {
      return "手机号登录"
    },

    placeholderText() {
      return "请输入手机号"
    },

    placeholderPwdText() {
      return "请输入验证码"
    },

    getSenconds() {
      return this.seconds - 1
    },

    getAgreeImg() {
      return this.isSelectProtocal ? require('@/assets/img/login/icon_login_agree.png') : require('@/assets/img/login/ico-circle-gray.png')
    },

  },

  watch: {
    phoneNo(val) {
      if (!val) {
        this.isShowPhoneX = false
        return
      }
      this.isShowPhoneX = true
    },
    password(val) {
      if (!val) {
        this.isShowCodeX = false
        return
      }
      this.isShowCodeX = true
    },

    seconds(val) {
      if (!val) {
        this.getCodeText = '获取验证码'
        this.seconds = 60
        clearInterval(this.timer)
        this.codeSended = false
      }
    }

  },

  created() {
    let env = 'sandbox'
    if (process.env.NODE_ENV == "production") {
      env = 'production'
    }
    TAL_UC && TAL_UC.rankConfig({
      'client-id': '153601', // client-id由平台发放权限码，接入之前向平台申请
      'env': env,      // 环境标识： 'sandbox': 沙箱环境； 'production': 线上生产环境；默认为生产(备注，引入npm包才需要该字段)
      'entity': '', // 业务主体域名拆分标识：2: 非营利主体，域名为vdyoo.com； 1或者不传以及其他为: 营利主体，域名为100tal.com  （1.19.06开始支持）
      'domain': '', // 参照上述注释信息，一般不需要进行配置（v1.19.01版sdk开始支持）
      'loginout_callback': function (res) { // 未登录/登录失效统一处理回调方法
        console.log(res, '=== 未登录/登录失效统一处理回调方法 =======')
        // res.name代表调用的方法名（checkHeartbeat是心跳的接口名，其余是按照业务方调用的接口而定）
      }
    })
    TAL_UC.configNVC({
      renderToEle: '#xes-1v1-login-code',
      isH5: true
    })
  },

  methods: {
    clearPhone() {
      this.phoneNo = ''
    },

    inputBlur(type) {
      const config = {
        1: () => {
          this.isShowPhoneX = false
        },
        2: () => {
          this.isShowCodeX = false
        }
      }
      config[type]()
    },
    inputMobile(e) {
      this.formatMobile(e)
      this.phoneNo = e.target.value
    },

    inputMobileCode(e) {
      this.password = e.target.value
    },
    inputFoucs(type) {
      const config = {
        1: () => {
          this.isShowPhoneX = !!this.phoneNo
        },
        2: () => {
          this.isShowCodeX = !!this.phoneCode
        }
      }
      config[type]()
    },
    formatMobile(e) {
      let val = e.target.value
      let selStart = e.target.selectionStart // 选中区域左边界位置
      let mobileLen = val.length
      let value = this.getValue(e, val).substr(0, 11) // 获取输入/粘贴内容,并截取前11位
      let len = value.length
      if (len > 3 && len < 8) {
        value = value.replace(/^(\d{3})/g, '$1 ')
      } else if (len >= 8) {
        value = value.replace(/^(\d{3})(\d{4})/g, '$1 $2 ')
      }
      e.target.value = value
      if (selStart !== mobileLen) {
        if (selStart === 3) {
          selStart++
        }
        // 设置光标位置
        e.target.selectionStart = this.$refs.phoneNo.selectionEnd = selStart
      }
    },

    clearPwd() {
      this.password = ''
    },

    getValue(e, val) {
      let value = ''
      if (e.type === 'keyup') {
        value = val.replace(/\D/g, '')
      } else if (e.type === 'paste') {
        let clipboardData = event.clipboardData || window.clipboardData
        value = clipboardData.getData('Text') // 获取剪贴板text格式的数据
        value = value.replace(/\D/g, '')
      }
      return value
    },

    clickProtocal(url) {
      window.history.pushState('preProtcal', 'preProtcal')
      setTimeout(() => {
        window.location.href = url
        window.history.pushState('protcal', 'protcal')
        // 是为了解决在ios上，输入账号/密码，点击协议进入查看再返回来的时候，密码展示不出来，其实是有值的问题
        if (this.pwdType !== 'text') {
          this.pwdType = 'text'
          this.changePwdType = true
        }
      }, 100)
    },
    changeType() {
      this.phoneNo = ''
    },

    loginWithCode() {
      if (this.phoneNo && this.phoneCode && this.isSelectProtocal) {
        this.loading = true
        const phoneNum = this.phoneNo.replace(/\s+/g, '')
        let params = {
          data: {
            phone: phoneNum,    // 地区不同手机号码规则不同
            phone_code: 86,    // 手机地区码
            sms_code: this.phoneCode    // 短信验证码
          },
          success: this.fusion_login_result,
          fail: this.fusion_login_fail,
          closeCaptchaCallback: function () { // 如果需要处理滑块加载失败后的图形验证码用户手动点击关闭时需要传递回调方法【1.11.02版本支持】
            console.log('关闭图形验证弹窗') // 接入方需要处理的方法，例如关闭弹窗后刷新页面，或者提交/登录注册按钮取消置灰等
            // body...
          }
        };
        TAL_UC.loginSms(params)
      }
    },

    login_result: function (res) {
      if (res.error_code === 0) {
        if (JSON.stringify(res) !== "{}") {
          if (res.result) {
            localStorage.setItem("talToken", res.result.tal_token)
            localStorage.setItem("talUid", res.result.uid)
            localStorage.setItem("talUserName", res.result.nick_name)
            this.getUserInfo()
          }
        }
      } else {
        this.loading = false
        Toast(res.errmsg)
      }
    },

    getUserInfo() {

      let tempUid = localStorage.getItem("talUid")
      // 获取用户信息
      let userParams = {
        "uid": tempUid
      }
      this.$api.clueTeacherForm.getUserInfo(userParams).then((res) => {
        if (res.error_code === 0) {
          this.user_uid = parseInt(res.result.uid)
          this.user_grade_name = res.result.grade_name
          this.user_grade = res.result.grade
          this.user_grade_name = res.result.grade_name
          this.user_real_name = res.result.real_name
          this.user_city_code = res.result.city_code
          this.user_city_name = res.result.city_code_name
          this.user_sex = res.result.sex
          localStorage.setItem("talUserGrade", res.result.grade)
          localStorage.setItem("talUserCity", res.result.city_code)
          this.getFamily()
        } else {
          Toast(res.errmsg)
          this.loading = false
        }
      })

    },
    getFamily() {
      this.$api.clueTeacherForm.getFamilyList().then((res) => {
        this.loading = false
        if (res.error_code === 0) {
          if (JSON.stringify(res) !== "{}") {
            let familyList = []
            if (res.result) {
              familyList = res.result.list
            }
            // if (res.result && res.result.list.length > 0) {
            //   // 选择学员
            // } else {
            //   res.result.list = []
            // }
            if (familyList.length <= 0) {
              // 选择学员
              familyList.push({
                uid: this.user_uid,
                grade: this.user_grade,
                grade_name: this.user_grade_name,
                city_code: this.user_city_code,
                city_code_name: this.user_city_name,
                avatar_url: this.user_avatar_url,
                real_name: this.user_real_name,
                sex:this.user_sex
              })
            }

            let str = JSON.stringify(familyList)
            localStorage.setItem("talFamily", str)
            this.$router.push({
              path: "/auth/SelectStu",
              query: {
                familyList: familyList
              }
            });
          }
        } else {

          Toast('请求异常，请重试')
        }
      });
    },
    fusion_login_result: function (res) {
      if (JSON.stringify(res) !== "{}") {
        if (res.errcode === 0) {
          let params = {
            code: res.data.code,
            client_id: 153601,
            type: 1,
          }
          this.$api.clueTeacherForm.loginWithCode(params).then(this.login_result);
        } else {
          this.loading = false
          Toast(res.errmsg)
        }
      }
    },
    fusion_login_fail: function (error) {
      this.loading = false
      Toast(error)
    },
    setIntervalSeconds() {
      this.getCodeText = `${this.seconds}s`
      this.timer = setInterval(() => {
        this.seconds -= 1
        this.getCodeText = `${this.seconds}s`
        if (!this.seconds) {
          this.getCodeText = '获取验证码'
          this.seconds = 60
          clearInterval(this.timer)
          this.codeSended = false
        }
      }, 1000)
    },
    fusion_sms_result: function (res) {
      if (JSON.stringify(res) !== "{}") {
        if (res.errcode === 0) {
          this.codeSended = true
          this.setIntervalSeconds()
        } else {
          Toast(res.errmsg)
        }
      } else {
        Toast("网络异常，请重试")
      }

    },
    sendSms() {
      const phoneNum = this.phoneNo.replace(/\s+/g, '')
      if (!phoneNum) {
        Toast("请输入手机号")
        return
      } else if (phoneNum.length !== 11) {
        Toast("手机号格式有误")
        return;
      }
      let params = {
        data: {
          send_type: 1,
          phone_code: '86',
          phone: phoneNum
        },
        success: this.fusion_sms_result,
        fail: function (error) {
          Toast(error.msg || '验证码发送失败')
        }
      };
      TAL_UC.sendSMSCodeLogin(params)
    },
    agreeProtocal() {
      this.isSelectProtocal = !this.isSelectProtocal
    },

    switchAccountLogin() {
      this.$router.push({
        path: "/auth/loginPwd"
      });
    }
  },
}
</script>
<style lang="scss" scoped>
.xes-1v1-login-div{
  width: 100%;
  height: 100%;
}
.xes-1v1-login-code {

  padding-left: 40px;
  padding-right: 40px;
  padding-top: 32px;
  width: 100%;
  height: 100%;

  &-top {
    width: 100%;
    height: 100px;
  }

  &-customer {
    float: right;
    display: block;
    width: 20px;
    height: 20px;
  }

  &-title {
    font-size: 24px;
    font-weight: bold;
    color: #333333;
    text-align: left;
  }

  &-tips {

    margin-top: 8px;
    font-size: 14px;
    color: #999999;
    text-align: left;
  }

  &-phone {
    width: 100%;
    margin-top: 40px;
    position: relative;

    &-phone {
      flex-direction: row;
      border-bottom: #E7E8EA 1px solid;
      height: auto;

      .xes-1v1-login-code-area-code {
        font-weight: 400;
        display: inline-block;
        width: auto;
        height: 44px;
        font-size: 16px;
        color: #000C1D;
        text-align: left;;
      }

      .xes-1v1-login-code-phone-input {
        margin-left: 10px;
        border: none;
        height: 44px;
        font-size: 16px;
        font-weight: 500;
        color: #000C1D;
        padding: 0;
        outline: none;
        caret-color: #E02727;
      }
    }

    &-code {
      border-bottom: #E7E8EA 1px solid;
      padding-bottom: 5px;
      margin-top: 24px;
      display: flex;
      flex-direction: row;
      //height: 144px;
      //margin: 20px 0 0 32px;

      &-input {
        width: 150px;
        padding: 0;
        border: none;
        height: 44px;
        font-size: 16px;
        font-weight: 500;
        color: #000C1D;
        outline: none;
        caret-color: #E02727;
      }

      &-get-code {
        position: absolute;
        right: 0;
        width: auto;
        font-size: 13px;
        margin-bottom: 5px;
        border-radius: 8px;
        padding: 10px;
        background-color: #E02727;
        color: #fff;
      }

      i{
        font-style: normal;
      }
    }

  }

  &-protcal {
    margin-top: 35px;
    display: flex;
    flex-direction: row;

    &-circle-select {
      width: 14px;
      height: 14px;
      margin: 5px 3px 0 0;
    }

    &-text {
      .xes-1v1-login-code-protcal-des {
        color: #999999;
        font-size: 11px;

      }

      .xes-1v1-login-code-protcal-link {
        color: #222222;
        font-size: 11px;
      }
    }
  }

  &-btn {
    overflow: hidden;

    button {
      display: block;
      border: none;
      border-radius: 22px;
      background-color: #dcdee0;
      color: #fff;
      font-size: 16px;
      line-height: 44px;
      font-weight: 500;
      width: 100%;
      height: 44px;
      text-align: center;
      margin-top: 32px;
    }

    button.active {
      background: #E02727;
    }
  }

  &-switch {
    width: 100%;
    margin: 16px 0 0 0;

    p {
      color: #666666;
      text-align: center;
      font-size: 12px;
    }
  }
}

</style>